import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { returnToProvisionPropType } from './propTypes';
import AgGrid from '../shared/agGrid/agGrid.component';
import returnToprovisionColumnDefs from './columnDefinitions';
import CheckboxCellRenderer from '../shared/agGrid/cellRenderers/checkboxCellRenderer.component';
import Button from '../shared/button.component';

class ReturnToProvisionGrid extends PureComponent {
  static propTypes = {
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    rtpDetails: PropTypes.arrayOf(returnToProvisionPropType).isRequired,
    returnToProvisionLoading: PropTypes.bool.isRequired,
    uploadRTPAction: PropTypes.func.isRequired,
  };

  state = {
    rtpChangesForReview: [],
  };

  handleCheckboxSelectionChanged = selectedRtpChangeId => {
    this.setState(({ rtpChangesForReview }) => {
      if (rtpChangesForReview.includes(selectedRtpChangeId)) {
        return {
          rtpChangesForReview: rtpChangesForReview.filter(
            rtpChangeId => rtpChangeId !== selectedRtpChangeId
          ),
        };
      }

      return {
        rtpChangesForReview: [
          ...rtpChangesForReview,
          selectedRtpChangeId,
        ],
      };
    }, () => {
      this.refreshCells();
    });
  };

  selectAllRows = () => {
    const filteredRows = this.getFilteredRowNodes();

    this.setState({
      rtpChangesForReview: filteredRows.map(row => row.data.rtpChangeId),
    }, () => {
      this.refreshCells();
    });
  };

  clearAllRows = () => {
    this.setState({
      rtpChangesForReview: [],
    }, () => {
      this.refreshCells();
    });
  };

  getFilteredRowNodes = () => {
    const rowNodes = [];
    this.gridApi.forEachNodeAfterFilter(rowNode => rowNodes.push(rowNode));
    return rowNodes;
  };

  refreshCells = () => {
    this.gridApi.refreshCells({ force: true });
  };

  handleEnterKeyPress = params => {
    this.preventSettingPreviousValue = true;
    params.api.stopEditing();
  };

  onGridReady = params => {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
  };

  submitSelectedCells = () => {
    const { rtpChangesForReview } = this.state;
    const { rtpDetails } = this.props;

    const selectedRows = rtpDetails.filter(rateChange =>
      rtpChangesForReview.includes(rateChange.rtpChangeId));

    this.props.uploadRTPAction(selectedRows);
    this.refreshCells();
  };

  render() {
    const {
      period,
      rtpDetails,
      returnToProvisionLoading,
    } = this.props;

    const extendedColumnDefs = [
      {
        headerName: '',
        field: 'rtpChangeId',
        cellRenderer: CheckboxCellRenderer(),
        cellRendererParams: {
          isChecked: value => this.state.rtpChangesForReview.includes(value),
          onSelect: this.handleCheckboxSelectionChanged,
        },
        width: 50,
        minWidth: 50,
      },
      ...returnToprovisionColumnDefs(this.handleEnterKeyPress),
    ];

    return (
      <div className="ag-grid-full-page-with-secondary-menu">
        <div className="row no-gutters">
          <div className="col">
            <h5>U.S. Federal Upload</h5>
          </div>
          <div className="d-flex flex-row float-right align-items-center">
            <Button
              type="button"
              kind="secondary"
              className="a-mx-10"
              onClick={this.submitSelectedCells}
            >
              Upload to Federal
            </Button>
            <Button
              type="button"
              kind="primary"
            >
              Export
            </Button>
          </div>
        </div>
        <div>
          <AgGrid
            columnDefs={extendedColumnDefs}
            headerHeight={50}
            rowData={rtpDetails}
            period={period}
            isGridLoading={returnToProvisionLoading}
            onGridReady={this.onGridReady}
            withSearchBar
            suppressScrollOnNewData
          />
        </div>
        <div className="row no-gutters">
          <div className="col">
            <Button
              type="button"
              kind="secondary"
              onClick={this.selectAllRows}
            >
              Select All
            </Button>
            <Button
              type="button"
              kind="secondary"
              className="a-mx-10"
              onClick={this.clearAllRows}
            >
              Clear All
            </Button>
          </div>
        </div>
      </div>

    );
  }
}

export default ReturnToProvisionGrid;
